<div class="basket-timer" role="region" [attr.aria-label]="'BASKET_TIMER.LABEL' | translate">
	<p class="basket-timer__time" aria-hidden="true">{{ remaining }}</p>
	<p class="basket-timer__text">{{ 'BASKET_TIMER.WARNING' | translate }}</p>
	@if (!extended) {
		<button type="button" class="govuk-button basket-timer__button" (click)="extend()">
			{{ 'BASKET_TIMER.EXTEND' | translate }}<span class="govuk-visually-hidden"> {{ 'BASKET_TIMER.EXTEND_HIDDEN' | translate }}</span>
		</button>
	}
	<span class="govuk-visually-hidden" aria-live="polite">{{ announcement }}</span>
</div>
